module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/icon4.3360968c.png";